export default __webpack_public_path__ + "static/media/edit.d75adbda.svg";